import Cookies from "js-cookie";
import React from "react";
import { Navigate } from "react-router-dom";

const LocalRoutes = ({ children }) => {
  const valid =
    sessionStorage.getItem("referredAs") == "User"
      ? !Cookies.get("accessToken")
      : !Cookies.get("pfaccessToken");
  return valid ? children : <Navigate to="/portal/dashboard" />;
};

export default LocalRoutes;
